import { styled } from 'styled-system/jsx'

const PageContainer = styled('div', {
  base: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background:
      'linear-gradient(135deg, {colors.quickpass.surfaceCool} 0%, {colors.quickpass.surface} 60%, #FEF0FF 100%)',
    padding: '24px',
  },
})

const ContentCard = styled('div', {
  base: {
    width: '100%',
    maxWidth: '380px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 24px 60px -20px rgba(128, 84, 255, 0.18)',
    padding: '32px 28px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '14px',
    textAlign: 'center',
  },
})

const Wordmark = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '22px',
    fontWeight: '800',
    letterSpacing: '-0.5px',
    color: 'quickpass.primary',
    margin: '0',
  },
})

const Heading = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '22px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.4px',
  },
})

const Subheading = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
    margin: '0',
    lineHeight: '1.55',
  },
})

const WidgetContainer = styled('div', {
  base: {
    width: '100%',
    marginTop: '4px',
  },
})

const ErrorBanner = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.warmth',
    padding: '10px 14px',
    borderRadius: 'sm',
    width: '100%',
  },
})

export {
  PageContainer,
  ContentCard,
  Wordmark,
  Heading,
  Subheading,
  WidgetContainer,
  ErrorBanner,
}
